const social = {
	el: {
		socialItem: document.querySelectorAll('.js-social')
	},

	fxPopupCenter(url, w = 600, h = 400) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left,
			dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top,
			width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
			height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
			left = ((width / 2) - (w / 2)) + dualScreenLeft,
			top = ((height / 2) - (h / 2)) + dualScreenTop,
			newWindow = window.open(url, 'Share', `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`)
		// Puts focus on the newWindow  
		window.focus ? newWindow.focus() : ''
	},

	events() {
		this.el.socialItem.forEach(el => el.addEventListener('click', e => {
			e.preventDefault()
			const encodedShareUrl = decodeURIComponent(location.href),
				shareUrl = `${e.currentTarget.dataset.url}${encodedShareUrl}`

			this.fxPopupCenter(shareUrl)
		}))
	},

	init() {
		this.events()
	}

}

social.init()